import DataTable, { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import * as Alert from '../../../../components/Alert/Alert';
import { endpoint } from '../../../pages';
import * as BeMaccaferriStoreHelper from '../../../api/store/BeMaccaferriStoreHelper';
import { endpointMacra1 } from '../../pages';
import { DataRow, ITableProps } from './ITable';
import './Table.scss';
import { endpointMacra2 } from '../../../MACRA_2/pages';

const Table = (props: ITableProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const columns: TableColumn<DataRow>[] = [
        {
            name: 'Name',
            selector: row => row.name,
        },
        {
            name: 'Creation date',
            selector: row => new Date(row.creationDate).toDateString(),
        },
        {
            name: 'Actions',
            button: true,
            cell(row, rowIndex, column, id) {
                return (
                    <div className='table-action'>
                        <i className='fa-solid fa-trash delete cursor-pointer' onClick={e => handleDelete(row)}></i>
                        {!props.isDocument && <i className='fa-solid fa-pen edit cursor-pointer' onClick={e => handleEdit(row)}></i>}
                    </div>
                );
            },
        },
    ];

    const handleDelete = (row: DataRow) => {
        Alert.warning(t('header_new_button_alert_title'), undefined, true).then(async result => {
            if (result.isConfirmed) {
                if (props.isDocument) {
                    props.onDeleteRow!(row);
                } else if (row.isTemplate) {
                    if (props.isMacra2) {
                        var res = await BeMaccaferriStoreHelper.deleteTemplateGCSByIdAsync(row.id);
                    } else {
                        var res = await BeMaccaferriStoreHelper.deleteTemplateCBPByIdAsync(row.id);
                    }
                    if (res.data) {
                        props.onChangePage!(1, 0);
                    }
                } else {
                    var res = await BeMaccaferriStoreHelper.deleteMaterialByIdAsync(row.id);
                    if (res.data) {
                        props.onChangePage!(1, 0);
                    }
                }
            }
        });
    };

    const handleEdit = (row: DataRow) => {
        if (props.isMacra2) {
            navigate(`${endpointMacra2.macra2BackofficeTemplate}/${row.id}`);
        } else {
            if (row.isTemplate) navigate(`${endpointMacra1.macra1BackofficeTemplate}/${row.id}`);
            else navigate(`${endpoint.backofficeMaterial}/${row.id}`);
        }
    };

    return (
        <DataTable
            columns={columns}
            data={props.data}
            progressPending={props.progressPending}
            pagination={props.pagination}
            paginationServer={props.paginationServer}
            paginationTotalRows={props.paginationTotalRows}
            onChangeRowsPerPage={props.onChangeRowsPerPage}
            onChangePage={props.onChangePage}
            dense
        />
    );
};

export default Table;
